export default theme => ({
  wrapper: {
    borderTop: `6px solid ${theme.palette.primary.main}`,
    borderRadius: 0,
  },
})
